import React, { useState, useEffect, useRef  } from "react";
import {
  Box,
  Typography,
  Paper,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  CircularProgress,
} from "@mui/material";
import { BarChart, PieChart } from "@mui/x-charts";
import { Checkbox, ListItemText } from "@mui/material";
import styles from "../css/Graphics.module.css";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";


export default function Graphics() {
  const [departamentos, setDepartamentos] = useState([]);
  const [municipios, setMunicipios] = useState([]);
  const [resultados, setResultados] = useState([]);
  const [loading, setLoading] = useState(false);

  const [selectedDepartamento, setSelectedDepartamento] = useState("");
  const [selectedMunicipio, setSelectedMunicipio] = useState("");
  const [selectedPregunta, setSelectedPregunta] = useState([]);
  const [generandoPDF, setGenerandoPDF] = useState(false);
  const YAxisName = "Cantidad de Respuestas";
  const chartsRef = useRef();


  const preguntas = [
    { id: 1, texto: "1. ¿En su municipio se tiene activada la Mesa técnica de atención a la Desnutrición aguda?" },
    { id: 2, texto: "2. ¿En su municipio se tiene Plan Municipal de intervenciones de acuerdo al análisis de situación?" },
    { id: 3, texto: "3. ¿En su municipio se hizo la identificación de determinantes de la Situación de la Denutrición Aguda?" },
    { id: 4, texto: "4. ¿En el Plan municipal de intervenciones se tiene incluido el Club de Nutrición?" },
    { id: 5, texto: "5. ¿En el Plan municipal de intervenciones se tiene incluida la Estrategia de Comunicación para el Conocimiento familiar y comunitario de DA?" },
    { id: 6, texto: "6. ¿En el Plan municipal de intervenciones se tiene incluida la intensificación de acciones en el tema de Aguas y Saneamiento?" },
    { id: 7, texto: "7. ¿En el Plan municipal de intervenciones se tiene incluida la realización de MODA y la Socialización de los resultados?" },
    { id: 8, texto: "8. ¿En el Plan municipal de intervenciones se tiene incluido el Protocolo de Actuación Conjunta (Asistencia alimentaria, Producción de alimentos, Bono nutrición, Bono salud, Protocolo atención a DA de MSPAS, RSO?" },
    { id: 9, texto: "9. ¿En el Plan municipal de intervenciones se tienen incluidas intervenciones y recursos del Gobierno municipal?" },
    { id: 10, texto: "10. ¿Qué porcentaje de avance se tiene en el Plan Municipal de intervenciones?" },
    { id: 11, texto: "11. ¿En su municipio se han priorizado comunidades para intensificar las acciones?" },
    { id: 12, texto: "12. ¿Cuántas comunidades han sido priorizadas en su municipio?" },
    { id: 13, texto: "13. ¿Cuántas comunidades priorizadas tienen redes de apoyo en su municipio?" },
    { id: 14, texto: "14. ¿Cuál es el número total (acumulado) de niñas y niños con desnutrición aguda, del listado nominal, que han sido monitoreados?" },
    { id: 15, texto: "15. ¿Cuál es el porcentaje de niñas y niños con Desnutrición Aguda Monitoreados a la fecha? " },
    { id: 16, texto: "16. ¿En la reunión mensual de COMUSAN del municipio, se realizó presentación de resultados de MODA? " },
    { id: 17, texto: "17. ¿En la COMUSAN de su municipio se elaboró informe registrando avances, desafíos y gestiones realizadas a nivel territorial y central?" },
    { id: 18, texto: "18. ¿Ha inicios del mes que se está reportando recibieron el listado nominal de niñas y niños con Desnutrición aguda?" },
    { id: 19, texto: "19. ¿Cuál es el número total (acumulado) de niñas y niños con desnutrición aguda, que cuentan CON CUI, que han sido incluidos en el listado nominal?" },
    { id: 20, texto: "20. ¿Cuál es el número acumulado de niñas y niños con desnutrición aguda, SIN CUI que han sido incluidos en el listado nominal?" },
    { id: 21, texto: "21. ¿Cuál es el número acumulado de niñas y niños que han sido localizados y trasladados a la delegación departamental para su reporte a Oficinas centrales?" },
    { id: 22, texto: "22. ¿Cuál es el porcentaje de niñas y niños con Desnutrición Aguda, SIN CUI, que han sido localizados en el municipio?" },
    { id: 23, texto: "23. ¿En el municipio se cuenta con el registro de familias que han sido beneficiadas con programas sociales o institucionales?" },
    { id: 24, texto: "24. ¿Cuántas familias de niños con Desnutrición aguda, reciben el Bono Nutrición?" },
    { id: 25, texto: "25. ¿Cuántas familias de niños con Desnutrición aguda, reciben Asistencia alimentaria por NDA?" },
    { id: 26, texto: "26. ¿Cuántas familias de niños con Desnutrición aguda, reciben Atención del MSPAS?" },
    { id: 27, texto: "27. ¿Cuántas familias de niños con Desnutrición aguda, reciben Asistencia técnica de MAGA para producción agropecuaria?" },
    { id: 28, texto: "28. ¿Cuántas niñas y niños con Desnutrición aguda, del listado nominal, corresponden a las comunidades priorizadas?" },
    { id: 29, texto: "29. ¿Cuántas niñas y niños con Desnutrición aguda, que corresponden a las comunidades priorizadas, han sido monitoreados?" },
  ];

  const hitosConfig = [
    { id: 4, titulo: "Club de Nutrición" },
    { id: 5, titulo: "Estrategia CCSyC" },
    { id: 6, titulo: "Agua y Saneamiento" },
    { id: 7, titulo: "MODA" },
    { id: 8, titulo: "Protocolo de Actuación Conjunta" },
    { id: 9, titulo: "Intervenciones Municipales" },
  ];

  const [anios, setAnios] = useState([]);
  const [meses, setMeses] = useState([]);

  const [selectedAnio, setSelectedAnio] = useState("");
  const [selectedMes, setSelectedMes] = useState("");
  const [deptoLocked, setDeptoLocked] = useState(false);
  const [muniLocked, setMuniLocked] = useState(false);


  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user"));
    if (!user) return;

    fetch(`/user-location?username=${user.username}`)
      .then(res => res.json())
      .then(data => {
        if (data.type === "department") {
          setSelectedDepartamento(data.departamentoId);
          setDeptoLocked(true);
          setSelectedMunicipio("");
          setMuniLocked(false);
        }

        if (data.type === "municipality") {
          setSelectedDepartamento(data.departamentoId);
          setDeptoLocked(true);
          setSelectedMunicipio(data.municipioId);
          setMuniLocked(true);
        }

        if (data.type === "central") {
          setDeptoLocked(false);
          setMuniLocked(false);
        }
      })
      .catch(err => console.error("Error al cargar user-location:", err));
  }, []);



  useEffect(() => {
    fetch(`/departamentos-con-datos`)
      .then((res) => res.json())
      .then(setDepartamentos)
      .catch((err) => console.error("Error al cargar departamentos:", err));
  }, []);

  useEffect(() => {
    if (selectedDepartamento) {
      fetch(`/municipios-con-datos/${selectedDepartamento}`)
        .then((res) => res.json())
        .then(setMunicipios)
        .catch((err) => console.error("Error al cargar municipios:", err));
    } else {
      setMunicipios([]);
    }
  }, [selectedDepartamento]);

  useEffect(() => {
    fetch(`/anios-disponibles`)
      .then(res => res.json())
      .then(setAnios)
      .catch(err => console.error("Error al cargar años:", err));
  }, []);

  useEffect(() => {
    if (!selectedAnio) { setMeses([]); return; }

    fetch(`/meses-disponibles/${selectedAnio}`)
      .then(res => res.json())
      .then(setMeses)
      .catch(err => console.error("Error al cargar meses:", err));
  }, [selectedAnio]);



  useEffect(() => {
    setLoading(true);

    let endpoint = `/resultados`;

    if (selectedMunicipio) {
      endpoint = `/resultados/municipio/${selectedMunicipio}`;
    } else if (selectedDepartamento) {
      endpoint = `/resultados/departamento/${selectedDepartamento}`;
    }

    const params = new URLSearchParams();
    if (selectedAnio) params.append("anio", selectedAnio);
    if (selectedMes) params.append("mes", selectedMes);

    const url = params.toString() ? `${endpoint}?${params.toString()}` : endpoint;

    fetch(url)
      .then((res) => res.json())
      .then((data) => {
        const resultadosFormateados = [];

        for (let i = 1; i <= 29; i++) {
          const siKey = `p${i}_si`;
          const noKey = `p${i}_no`;
          const promKey = `p${i}`;
          const tieneSiNo = Object.hasOwn(data, siKey) && Object.hasOwn(data, noKey);

          if (tieneSiNo) {
            resultadosFormateados.push({
              preguntaId: i,
              tipo: "si_no",
              si: Number(data[siKey]) || 0,
              no: Number(data[noKey]) || 0,
            });
          } else if (Object.hasOwn(data, promKey)) {
            resultadosFormateados.push({
              preguntaId: i,
              tipo: "numerica",
              valor: data[promKey] ? parseFloat(data[promKey]) : 0,
            });
          }
        }
        setResultados(resultadosFormateados);
      })
      .catch((err) => console.error("Error al obtener resultados:", err))
      .finally(() => setLoading(false));
  }, [selectedDepartamento, selectedMunicipio, selectedAnio, selectedMes]);

  const cargarImagen = (src) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.src = src;
      img.crossOrigin = "anonymous";
      img.onload = () => resolve(img);
      img.onerror = reject;
    });
  };


const handlePrintCharts = async () => {
  setGenerandoPDF(true);

  try {
    if (!chartsRef.current) return;

    const pdf = new jsPDF({ orientation: "portrait", unit: "pt", format: "letter" });
    const pageWidth = pdf.internal.pageSize.getWidth();
    const pageHeight = pdf.internal.pageSize.getHeight();

    const logo = await cargarImagen("/images/sesan.png");
    const logoWidth = 150;
    const logoHeight = (logo.height / logo.width) * logoWidth;

    const chartElements = chartsRef.current.querySelectorAll(`.${styles.chartCard}`);
    
    const chartsPerPage = 3;
    const margin = 40;
    const topOffset = 80;
    const availableHeight = pageHeight - topOffset - margin;
    const chartHeight = availableHeight / chartsPerPage;

    let currentPage = 0;
    let chartsOnCurrentPage = 0;
    let yOffset = topOffset;

    for (let i = 0; i < chartElements.length; i++) {
      if (i % chartsPerPage === 0) {
        if (i > 0) {
          pdf.addPage();
        }
        currentPage++;
        chartsOnCurrentPage = 0;
        yOffset = topOffset;
        
        pdf.addImage(logo, "PNG", pageWidth - logoWidth - 20, 5, logoWidth, logoHeight);
        pdf.setFontSize(14);
        pdf.text(`Reporte de Indicadores - Página ${currentPage}`, 20, 40);
      }

      const chart = chartElements[i];
      
      const canvas = await html2canvas(chart, { 
        scale: 1.5,
        useCORS: true,
        backgroundColor: "#ffffff"
      });
      
      const imgData = canvas.toDataURL("image/png");
      const imgProps = pdf.getImageProperties(imgData);

      const availableWidth = pageWidth - (2 * margin);
      const targetHeight = chartHeight - 10; 
      
      const imgWidth = availableWidth;
      const imgHeight = (imgProps.height * imgWidth) / imgProps.width;

      const finalHeight = Math.min(imgHeight, targetHeight);

      pdf.addImage(imgData, "PNG", margin, yOffset, imgWidth, finalHeight);
      
      yOffset += finalHeight + 15;
      chartsOnCurrentPage++;
    }

    pdf.save("reporte_graficas.pdf");
  } catch (error) {
    console.error("Error generando PDF:", error);
    alert("Error al generar el PDF. Por favor, intente nuevamente.");
  } finally {
    setGenerandoPDF(false);
  }
};






  const numericos = resultados.filter((r) => r.tipo === "numerica");
  const mediaTotal =
    numericos.length > 0
      ? numericos.reduce((acc, r) => acc + r.valor, 0) / numericos.length
      : 0;

  const seisHitos = resultados.filter((r) =>
    hitosConfig.some((h) => h.id === r.preguntaId)
  );

  const resetFiltros = () => {
    if (!deptoLocked) {
      setSelectedDepartamento("");
    }

    if (!muniLocked) {
      setSelectedMunicipio("");
    }

    setSelectedAnio("");
    setSelectedMes("");
    setSelectedPregunta([]);
  };



  return (
    <Box className={styles.container}>
      <Box className={styles.sidebar}>
        <Typography variant="h6" sx={{ mb: 2 }}>
          Filtros
        </Typography>
        <FormControl fullWidth sx={{ mb: 2 }} disabled={deptoLocked}>
          <InputLabel>Departamento</InputLabel>
          <Select
            value={selectedDepartamento}
            onChange={(e) => {
              if (!deptoLocked) {
                setSelectedDepartamento(e.target.value);
                setSelectedMunicipio("");
              }
            }}
            label="Departamento"
          >

            <MenuItem value="">Todos</MenuItem>
            {departamentos.map((d) => (
              <MenuItem key={d.departamentoId} value={d.departamentoId}>
                {d.departamentoName}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <FormControl fullWidth sx={{ mb: 2 }} disabled={!selectedDepartamento || muniLocked}>
          <InputLabel>Municipio</InputLabel>
          <Select
            value={selectedMunicipio}
            onChange={(e) => {
              if (!muniLocked) setSelectedMunicipio(e.target.value);
            }}
            label="Municipio"
          >

            <MenuItem value="">Todos</MenuItem>
            {municipios.map((m) => (
              <MenuItem key={m.municipioId} value={m.municipioId}>
                {m.municipioName}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <FormControl fullWidth sx={{ mb: 2 }}>
          <InputLabel>Año</InputLabel>
          <Select
            value={selectedAnio}
            onChange={(e) => { 
              setSelectedAnio(e.target.value);
              setSelectedMes("");
            }}
            label="Año"
          >
            <MenuItem value="">Todos</MenuItem>
            {anios.map(a => (
              <MenuItem key={a} value={a}>{a}</MenuItem>
            ))}
          </Select>
        </FormControl>

        <FormControl fullWidth sx={{ mb: 2 }} disabled={!selectedAnio}>
          <InputLabel>Mes</InputLabel>
          <Select
            value={selectedMes}
            onChange={(e) => setSelectedMes(e.target.value)}
            label="Mes"
          >
            <MenuItem value="">Todos</MenuItem>
            {meses.map(m => (
              <MenuItem key={m} value={m}>
                {new Date(0, m - 1).toLocaleString("es", { month: "long" })}
              </MenuItem>
            ))}
          </Select>
        </FormControl>


        <FormControl fullWidth sx={{ mb: 2 }}>
          <InputLabel>Indicador</InputLabel>
            <Select
              multiple
              value={selectedPregunta}
              onChange={(e) => {
                const value = e.target.value;
                if (value.length <= 8) {
                  setSelectedPregunta(value);
                }
              }}
              label="Indicador"
              renderValue={(selected) =>
                selected
                  .map((id) => preguntas.find((p) => p.id === id)?.texto)
                  .join(", ")
              }
            >
              {preguntas.map((p) => (
                <MenuItem key={p.id} value={p.id}>
                  <Checkbox checked={selectedPregunta.indexOf(p.id) > -1} />
                  <ListItemText primary={p.texto} />
                </MenuItem>
              ))}
            </Select>
          </FormControl>

<Box sx={{ display: "flex", justifyContent: "center", mb: 2 }}>
  <button
    onClick={handlePrintCharts}
    style={{
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      padding: "10px 18px",
      backgroundColor: "#01549f",
      border: "none",
      borderRadius: "6px",
      color: "white",
      cursor: generandoPDF ? "not-allowed" : "pointer",
      fontWeight: "bold",
      minWidth: "150px",
    }}
    disabled={generandoPDF}
  >
    Generar PDF
    <span style={{ display: "inline-flex", marginLeft: 8, width: 20, height: 20 }}>
      {generandoPDF && <CircularProgress size={20} />}
    </span>
  </button>
</Box>


        <Box sx={{ display: "flex", justifyContent: "center", mb: 2 }}>
          <button
            onClick={resetFiltros}
            style={{
              padding: "10px 18px",
              backgroundColor: "#d32f2f",
              border: "none",
              borderRadius: "6px",
              color: "white",
              cursor: "pointer",
              fontWeight: "bold",
            }}
          >
            Limpiar Filtros
          </button>
        </Box>

      </Box>

      <Box className={styles.chartArea} ref={chartsRef}>
  {loading ? (
    <Box sx={{ display: "flex", justifyContent: "center", mt: 10 }}>
      <CircularProgress />
    </Box>
  ) : (
    <>
      {selectedPregunta.length === 0 ? (
        <Paper elevation={5} className={styles.chartCard}>
          <Typography align="center" sx={{ mt: 1 }}>
            Selecciona hasta 8 indicadores para ver las gráficas
          </Typography>
        </Paper>
      ) : (
        selectedPregunta.map((preguntaId) => {
          if (preguntaId === "media") {
            return (
              <Paper key="media" elevation={5} className={styles.chartCard}>
                <Box sx={{ mb: 4 }}>
                  <Typography variant="h6" sx={{ textAlign: "center" }}>
                    Media de todos los indicadores
                  </Typography>

                  <Typography align="center" sx={{ mt: 1 }}>
                    Media general: {mediaTotal.toFixed(2)}%
                  </Typography>

                  <Box sx={{ display: "flex", justifyContent: "center" }}>
                    <PieChart
                      series={[
                        {
                          data: [
                            { id: 0, value: mediaTotal, label: "Media (%)", color: "#01549f" },
                            { id: 1, value: 100 - mediaTotal, label: "Restante", color: "#d32f2f" },
                          ],
                        },
                      ]}
                      width={400}
                      height={300}
                    />
                  </Box>
                </Box>
              </Paper>
            );
          }

          const resultado = resultados.find(
            (r) => r.preguntaId === Number(preguntaId)
          );

          if (!resultado) {
            return (
              <Paper key={preguntaId} elevation={5} className={styles.chartCard}>
                <Typography align="center" sx={{ mt: 2 }}>
                  No hay datos para el indicador {preguntaId}
                </Typography>
              </Paper>
            );
          }

          return (
            <Paper key={preguntaId} elevation={5} className={styles.chartCard}>
              <Box sx={{ mb: 4 }}>
                <Typography variant="h6" sx={{ textAlign: "center" }}>
                  {preguntas.find((p) => p.id === preguntaId)?.texto}
                </Typography>

                <Typography align="center" sx={{ mt: 1 }}>
                  {resultado.tipo === "si_no"
                    ? `Sí: ${resultado.si} | No: ${resultado.no}`
                    : `Valor promedio: ${(resultado.valor || 0).toFixed(2)}%`}
                </Typography>

                <Box sx={{ display: "flex", justifyContent: "center" }}>
                  {resultado.tipo === "si_no" ? (
                    <BarChart
                      xAxis={[{ scaleType: "band", data: [`Indicador ${preguntaId}`] }]}
                      yAxis={[{ label: YAxisName }]}
                      series={[
                        { label: "Sí", data: [resultado.si], color: "#01549f" },
                        { label: "No", data: [resultado.no], color: "#d32f2f" },
                      ]}
                      width={400}
                      height={300}
                      legend={{ position: "bottom" }}
                    />
                  ) : (
                    <PieChart
                      series={[
                        {
                          data: [
                            { id: 0, value: resultado.valor || 0, label: "Avance (%)", color: "#01549f" },
                            { id: 1, value: 100 - (resultado.valor || 0), label: "Restante", color: "#d32f2f" },
                          ],
                        },
                      ]}
                      width={400}
                      height={300}
                    />
                  )}
                </Box>
              </Box>
            </Paper>
          );
        })
      )}

      <Paper elevation={5} className={styles.chartCard}>
        <Typography variant="h6" sx={{ mb: 2, textAlign: "center" }}>
          Comparativa 6 Hitos Principales
        </Typography>

        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: `repeat(${hitosConfig.length}, 1fr)`,
            textAlign: "center",
            mb: 2,
            gap: 1
          }}
        >
          {hitosConfig.map((hito) => {
            const r = seisHitos.find((res) => res.preguntaId === hito.id);
            return (
              <Box key={hito.id}>
                <Typography sx={{ fontWeight: "bold", fontSize: "0.9rem" }}>
                  {hito.titulo}
                </Typography>
                <Typography variant="body2">
                  Sí: {r?.si || 0} | No: {r?.no || 0}
                </Typography>
              </Box>
            );
          })}
        </Box>

        <Box sx={{ display: "flex", justifyContent: "center" }}>
          <BarChart
            xAxis={[
              {
                scaleType: "band",
                data: hitosConfig.map((h) => h.titulo),
              },
            ]}
            yAxis={[{ label: YAxisName }]}
            series={[
              {
                label: "Sí",
                data: hitosConfig.map((h) => {
                  const r = seisHitos.find((res) => res.preguntaId === h.id);
                  return r?.si || 0;
                }),
                color: "#01549f",
              },
              {
                label: "No",
                data: hitosConfig.map((h) => {
                  const r = seisHitos.find((res) => res.preguntaId === h.id);
                  return r?.no || 0;
                }),
                color: "#d32f2f",
              },
            ]}
            width={1300}
            height={400}
          />
        </Box>

        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: `repeat(${hitosConfig.length}, 1fr)`,
            textAlign: "center",
            mb: 1,
            ml: "130px",
            mr: "50px"
          }}
        >
          {hitosConfig.map((hito) => {
            const r = seisHitos.find((res) => res.preguntaId === hito.id);
            return (
              <Box key={hito.id}>
                <Typography variant="body2" sx={{ mt: -3 }}>
                  Sí: {r?.si || 0} | No: {r?.no || 0}
                </Typography>
              </Box>
            );
          })}
        </Box>

        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: `repeat(${hitosConfig.length}, 1fr)`,
            textAlign: "center",
            mt: 2,
            mb: 1
          }}
        >
          {hitosConfig.map((hito) => {
            const r = seisHitos.find((res) => res.preguntaId === hito.id);
            const valor = r?.si > 0 ? 20 : 0;

            return (
              <Typography
                key={hito.id}
                variant="subtitle1"
                sx={{ fontWeight: "bold", color: "#01549f" }}
              >
                {valor}%
              </Typography>
            );
          })}
        </Box>

        {(() => {
          const totalReal = hitosConfig.reduce((acc, hito) => {
            const r = seisHitos.find((res) => res.preguntaId === hito.id);
            return acc + (r?.si > 0 ? 20 : 0);
          }, 0);

          const totalSobre100 = (totalReal / 100) * 100;

          return (
            <Typography align="center" sx={{ fontWeight: "bold", mb: 1 }}>
              Total: {Math.min(totalSobre100, 100).toFixed(2)} / 100
            </Typography>
          );
        })()}

        <Box sx={{ width: "80%", mx: "auto", mt: 1 }}>
          <Box
            sx={{
              height: "18px",
              backgroundColor: "#e0e0e0",
              borderRadius: "10px",
              overflow: "hidden"
            }}
          >
            <Box
              sx={{
                height: "100%",
                width: `${(
                  hitosConfig.reduce((acc, hito) => {
                    const r = seisHitos.find((res) => res.preguntaId === hito.id);
                    return acc + (r?.si > 0 ? 20 : 0);
                  }, 0) /
                  120 *
                  100
                ).toFixed(2)}%`,
                backgroundColor: "#01549f"
              }}
            />
          </Box>
        </Box>
      </Paper>
    </>
  )}
</Box>
    </Box>
  );
}